import { React } from 'react';
import {  Routes, Route } from 'react-router-dom';
import ShowNews from './ShowNews';
import CreateNews from './CreateNews';
import UpdateNews from './UpdateNews';

// This page need to install bootstrap axios and react-router-dom

function ManageNews() {
    return (
        <div>
            <Routes>
                <Route path='/' element={<ShowNews />}></Route>
                <Route path='/createNews' element={<CreateNews />}></Route>
                <Route path='/update/:id' element={<UpdateNews />} />
            </Routes>
        </div>
    )
}

export default ManageNews
